import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import User from '../views/sys/User.vue'
import Role from '../views/sys/Role.vue'
import Menu from '../views/sys/Menu.vue'
import UserCenter from "@/views/UserCenter";
import axios from "../axios";
import store from "../store"
import patientManagement from "../views/patientManagement";
import patientManagementOperation from "../views/patientManagement-operation";
import prescriptionManagement from "../views/prescriptionManagement";
import systemManagement from "../views/systemManagement";
import outpatientService from "../views/outpatientDoctorWorkstation/outpatientService/outpatientService";
import qs from "qs";

import TreeSelectorDemo from "@/views/TreeSelectorDemo";
Vue.use(VueRouter)

Vue.prototype.$qs = qs;

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/login',
    children: [
      {
        path: '/index',
        name: 'Index',
        component: Index
      },
      {
        path: '/userCenter',
        name: 'UserCenter',
        component: UserCenter
      },
      {
        path: '/tree-selector-demo',
        name: 'TreeSelectorDemo',
        component: TreeSelectorDemo
      },
      {
        icon: '',
        title: '患者管理',
        path: '/patientManagement',
        name: 'patientManagement',
        component: patientManagement,
        children: null,
      },
      {
        icon: '',
        title: '患者管理',
        path: '/patientManagementOperation',
        name: 'patientManagementOperation',
        component: patientManagementOperation,
        children: null,
      },
      {
        icon: '',
        title: '药方管理',
        path: '/prescriptionManagement',
        name: 'prescriptionManagement',
        component: prescriptionManagement,
        children: null,
      },
      {
        icon: 'el-icon-s-order',
        title: '门诊',
        path: '/outpatientService/outpatientService',
        name: 'outpatientService',
        component: outpatientService,
        children: null,
      },
      {
        icon: '',
        title: '医生评测 - 医生端',
        path: '/outpatientDoctorWorkstation/doctorEvaluation',
        name: 'doctorEvaluation',
        component: () => import('../views/outpatientDoctorWorkstation/DoctorEvaluation.vue'),
        children: null,
      },
      {
        icon: '',
        title: '医生评测 - 运营端',
        path: '/outpatientDoctorWorkstation/operationEvaluation',
        name: 'operationEvaluation',
        component: () => import('../views/outpatientDoctorWorkstation/OperationEvaluation.vue'),
        children: null,
      },
      {
        icon: 'el-icon-setting',
        title: '系统管理',
        path: '/systemManagement',
        name: 'systemManagement',
        component: systemManagement,
        children: [
          {
            icon: '',
            title: '用户管理',
            path: '/systemManagement/userManagement',
            name: 'userManagement',
            component: () => import('../views/systemManagement/userManagement.vue'),
            children: null,
          },
          {
            icon: '',
            title: '角色管理',
            path: '/systemManagement/roleManagement',
            name: 'roleManagement',
            component: () => import('../views/systemManagement/roleManagement.vue'),
            children: null,
          },
          {
            icon: '',
            title: '菜单管理',
            path: '/systemManagement/menuManagement',
            name: 'menuManagement',
            component: () => import('../views/systemManagement/menuManagement.vue'),
            children: null,
          },
          {
            icon: '',
            title: '医院管理',
            path: '/systemManagement/hospitalManagement',
            name: 'hospitalManagement',
            component: () => import('../views/systemManagement/hospitalManagement.vue'),
            children: null,
          },
          {
            icon: '',
            title: '健康评测建议',
            path: '/systemManagement/healthCheckAdvice',
            name: 'healthCheckAdvice',
            component: () => import('../views/systemManagement/healthCheckAdvice.vue'),
            children: null,
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// router.afterEach((to, from) => {
//
// })

router.beforeEach((to, from, next) => {
  // 添加无需登录的路由白名单
  const whiteList = ['/login', '/systemManagement']

  // 检查是否在白名单中（支持父级路径匹配）
  const isInWhiteList = whiteList.some(path => to.path === path || to.path.startsWith(path + '/'));
  if (isInWhiteList) {
    next() // 直接放行
    return
  }

  let hasRoute = store.state.menus.hasRoute
  if (!hasRoute && sessionStorage.getItem("User") && JSON.parse(sessionStorage.getItem("User")) !== null) {
    // 统一从 store action 加载菜单，设置allowForceRefresh为true确保每次重新登录都获取最新菜单
    store.dispatch('loadMenusOnce', { allowForceRefresh: true }).then(menuList => {
      let authorization = [];
      let newRoutes = router.options.routes;

      // 仅处理 API 返回的动态菜单
      menuList.forEach(menu => {
        let route = menuToRoute(menu);
        if (route) {
          // 检查是否已存在同名路由
          if (!router.hasRoute(route.name)) {
            router.addRoute('Home', route); // 添加到 'Home' 父路由下
          }
        }

        if (menu.children) {
          menu.children.forEach(e => {
            let childRoute = menuToRoute(e);
            if (childRoute) {
              // 检查是否已存在同名路由
              if (!router.hasRoute(childRoute.name)) {
                router.addRoute('Home', childRoute); // 添加到 'Home' 父路由下
              }
            }
          })
        }
      })

      // 注意：permList 已经在 loadMenusOnce action 中自动提取和设置了，不需要在这里设置
      // store.commit("setPermList", authorization) // 已移除，避免覆盖已提取的权限列表
      store.commit("changeRouteStatus", true)
      next();
    }).catch(() => {
      // 若加载失败，仍然放行，交给后续页面自行处理
      next();
    })
  } else {
    // 刷新后首次进入若目标路由不可用、或无任何tab记录，确保可达首页
    try {
      const tabsStr = sessionStorage.getItem('editableTabs')
      const tabs = tabsStr ? JSON.parse(tabsStr) : []
      if (!tabs || tabs.length === 0) {
        if (to.path !== '/index' && to.path !== '/login') {
          next('/index');
          return
        }
      }
    } catch (e) {}
    next();
  }
})

//导航转成路由
const menuToRoute = (menu) => {
  if (!menu.component) {
    return null;
  }
  let route = {
    name: menu.name,
    path: menu.path,
    meta: {
      icon: menu.icon,
      title: menu.title
    }
  }
  route.component = () => import('@/views/' + menu.component + '.vue')
  return route
}

export default router
